import React, { useState } from "react";

const InvestigativeActionDisplay = (props) => {

    const abilityID = props.item.id;

    const [isExpanded, setIsExpanded] = useState(false);

    // expand/collapse

    function toggleExpandDisplay() {
        setIsExpanded(!isExpanded);
    }

    function classNames(classes) {
        return Object.entries(classes)
            .filter(([key, value]) => value)
            .map(([key, value]) => key)
            .join(' ');
    }

    const expandClasses = {
        'App-action-expandicon': true,
        'expand-icon--selected': isExpanded
    };

    const expandClassNames = classNames(expandClasses);

    const labelClasses = {
        'App--action-label': true,
        'App--action-label-expand': isExpanded
    };

    const labelClassNames = classNames(labelClasses);

    const descriptionClasses = {
        'App--action-desc': true,
        'App--action-desc-expand': isExpanded
    };

    const descriptionClassNames = classNames(descriptionClasses);

    const titleClasses = {
        'App--action-title-label': true,
        'App--action-title-label-expand': isExpanded
    };

    const titleClassNames = classNames(titleClasses);

    return (
        <div className="App--general-action-row">
            <button type="button" onClick={toggleExpandDisplay} className="App--general-action-button">
                <div id={"action-display-" + abilityID} className="App-action-expand-button">
                    <div className={expandClassNames} />
                </div>
                <div className={labelClassNames}>
                    <div className={titleClassNames} >{props.item.name}</div>
                    <div className={descriptionClassNames}>
                        {props.item.description}
                    </div>
                </div>
            </button>
        </div>
    );
};

export default InvestigativeActionDisplay;